import styled from "styled-components";

interface OperacaoTagProps {
  value: any[];
}

function OperacaoTag({ value }: OperacaoTagProps) {
  if (!value) {
    return (
      <span>-</span>
    );
  }
  const operacoes = value.map(v => v.operacao);
  const op = new Set(operacoes);
  const arr = Array.from(op);
  return (
    <Container>
      {arr.length > 0 ? arr.map(operacao => (
        <Tag>{operacao}</Tag>
      )) : (
        <span>-</span>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 4px
`;

const Tag = styled.p`
  background-color: #e3f2fd;
  color: #1976d2;
  font-size: 12px;
  border-radius: 5px;
  padding: 4px;
`;

export default OperacaoTag;
